import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import React from 'react';

import {CREATE_FLOWS} from '../../../constants';
import {DARK_TEXT_COLOR, GREY_80, WHITE_100} from '../../../theme';

const styles = {
  container: {
    backgroundColor: WHITE_100,
    borderBottom: `0.0625rem solid ${GREY_80}`,
    flexShrink: 0,
  },
  inner: {
    alignItems: 'center',
    backgroundColor: WHITE_100,
    borderBottom: `0.0625rem solid ${GREY_80}`,
    justifyContent: 'space-between',
    paddingLeft: '1.5rem',
    paddingRight: '1rem',
    paddingY: '1rem',
    position: 'sticky',
    top: 0,
    zIndex: 1,
  },
  title: {
    color: DARK_TEXT_COLOR,
    fontSize: '1rem',
    fontWeight: '700',
    lineHeight: '120%',
  },
};

const getModalTitle = (createFlow) => {
  switch (createFlow) {
    case CREATE_FLOWS.rollforward:
      return 'Create report - Rollforward existing report';
    case CREATE_FLOWS.blankDocument:
      return 'Create report';
    case CREATE_FLOWS.pdf:
      return 'Create report - Rollforward from a PDF file';
    case CREATE_FLOWS.upload:
      return 'Create report - Upload file';
    case CREATE_FLOWS.pdfReviewAssistant:
      return 'Upload PDF for review assistant';
    default:
      return 'Create document';
  }
};

export const ModalHeader = ({
  createFlow,
  isIngestionComplete,
  isProcessing,
  onClose,
}) => {
  if (!isProcessing && isIngestionComplete) {
    return null;
  }

  const title = isProcessing
    ? 'Generating your new report'
    : `${getModalTitle(createFlow)}`;

  return (
    <Box sx={styles.container}>
      <Stack direction="row" sx={styles.inner}>
        <Typography sx={styles.title}>{title}</Typography>
        <IconButton onClick={onClose} size="small">
          <CloseIcon sx={{fontSize: '1.25rem'}} />
        </IconButton>
      </Stack>
    </Box>
  );
};

ModalHeader.propTypes = {
  createFlow: PropTypes.string,
  isIngestionComplete: PropTypes.bool.isRequired,
  isProcessing: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};
